import {
  differenceInCalendarDays,
  format,
  isSameDay,
  isToday,
  isYesterday,
} from 'date-fns'
import type { Activity, Channel, DayGroup, Outcome } from '../types/activity'

export function formatDuration(seconds: number): string {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${mins}m ${String(secs).padStart(2, '0')}s`
}

export function formatTime(iso: string): string {
  return format(new Date(iso), 'h:mm a')
}

export function formatFullTimestamp(iso: string): string {
  return format(new Date(iso), "EEE, MMM d, yyyy 'at' h:mm a")
}

export function relativeDay(iso: string): string {
  const date = new Date(iso)
  if (isToday(date)) return 'Today'
  if (isYesterday(date)) return 'Yesterday'
  const days = differenceInCalendarDays(new Date(), date)
  if (days < 7) return format(date, 'EEEE')
  return format(date, 'MMM d')
}

export function outcomeLabel(outcome: Outcome): string {
  switch (outcome) {
    case 'connected':
      return 'Connected'
    case 'no-answer':
      return 'No answer'
    case 'voicemail':
      return 'Voicemail'
    case 'sent':
      return 'Sent'
    case 'received':
      return 'Received'
    case 'completed':
      return 'Logged'
  }
}

export function isMeaningful(activity: Activity): boolean {
  return activity.outcome === 'connected' || activity.outcome === 'received'
}

export function channelLabel(channel: Channel): string {
  switch (channel) {
    case 'call':
      return 'Call'
    case 'sms':
      return 'Text'
    case 'email':
      return 'Email'
    case 'event':
      return 'Event'
  }
}

function sortDesc(list: Activity[]): Activity[] {
  return [...list].sort(
    (a, b) => new Date(b.at).getTime() - new Date(a.at).getTime(),
  )
}

export function groupTimeline(activities: Activity[]): DayGroup[] {
  const groups: DayGroup[] = []

  sortDesc(activities).forEach((activity) => {
    const date = new Date(activity.at)
    const last = groups[groups.length - 1]

    if (last && isSameDay(new Date(last.key), date)) {
      last.count += 1
      last.activities.push(activity)
      return
    }

    groups.push({
      key: activity.at,
      label: relativeDay(activity.at),
      dateLabel: format(date, 'MMM d, yyyy'),
      count: 1,
      activities: [activity],
    })
  })

  return groups
}
